import { render, staticRenderFns } from "./AccountingPappers.vue?vue&type=template&id=6944911f&"
import script from "./AccountingPappers.vue?vue&type=script&lang=js&"
export * from "./AccountingPappers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports